export interface CreditChipProps {
  balance: number;
  /** The service's judgment, not a threshold the client invents. */
  low?: boolean;
}

export function CreditChip({ balance, low = false }: CreditChipProps) {
  return (
    <span className={["creditchip", low ? "creditchip-low" : ""].filter(Boolean).join(" ")}>
      <span className="creditchip-dot" aria-hidden="true" />
      {balance} {balance === 1 ? "credit" : "credits"}
    </span>
  );
}
